import { useFiltersContext } from './useFiltersContext';
import { FDealType, dealTypeFromJsonQuery } from '../../../JsonQuery';

export function useDealType(): FDealType {
  const { jsonQuery } = useFiltersContext();

  return dealTypeFromJsonQuery(jsonQuery);
}
